var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-added-by",class:{ pickup: _vm.isPickup }},[_vm._v(" Added by "),_c('span',{class:{ bright: _vm.getAddedByAdditionalClass }},[_vm._v(" "+_vm._s(_vm.addedBy)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }